import { useMemo } from 'react'

import { useText } from '../../contexts/TextContext'
import { Order, OrderState } from '../../models/Order'
import { DashboardColumn } from '../../models/DashboardColumn'
import useOrders from '../../hooks/staffDashboard/useOrders'

interface Props {
    className?: string;
}

export default function OrdersBoard(props: Props) {
    const text = useText();
    const { ordersByState } = useOrders({ doneOrdersSlidingWindowSize: 1 });

    const columns: DashboardColumn[] = useMemo(() => [
        {
            id: 'paid',
            title: text.paid,
            state: OrderState.PAID,
        },
        {
            id: 'inProgress',
            title: text.inProgress,
            state: OrderState.IN_PROGRESS,
        },
        {
            id: 'done',
            title: text.done,
            state: OrderState.DONE,
        },
    ], [text.done, text.inProgress, text.paid]);

    const renderOrder = (order: Order) => {
        return (
            <div key={order.id} className={`dashboard-order ${order.state}`}>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="center bold">
                            {order.publicId || order.id}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={`flex-grow-1 d-flex pb-2 gap-4 ${props.className}`}>
            {columns.map((column) => {
                const orders = ordersByState.get(column.state) || [];
                return (
                    <div key={column.id} className={`order-column ${column.id}`}>
                        <div className='center mt-1 '>
                            <h4 className='m-0'>{column.title}</h4>
                        </div>
                        {orders.map(order => renderOrder(order))}
                    </div>
                );
            })}
        </div>
    )
}
